(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo_carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.logo-carousel-slider').forEach(carousel => {
    const perViewDesktop = parseInt(carousel.dataset.logosPerViewDesktop) || 8;
    const perViewMobile = parseInt(carousel.dataset.logosPerViewMobile) || 2;
    const showArrowsDesktop = carousel.dataset.showArrowsDesktop === 'true';
    const showArrowsMobile = carousel.dataset.showArrowsMobile === 'true';
    const prevBtn = carousel.querySelector('.swiper-button-prev');
    const nextBtn = carousel.querySelector('.swiper-button-next');

    // Responsive arrow visibility
    function updateArrows() {
      if (window.innerWidth < 768) {
        if (showArrowsMobile) {
          prevBtn.style.display = 'block';
          nextBtn.style.display = 'block';
        } else {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        }
      } else {
        if (showArrowsDesktop) {
          prevBtn.style.display = 'block';
          nextBtn.style.display = 'block';
        } else {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        }
      }
    }
    updateArrows();
    window.addEventListener('resize', updateArrows);

    if (typeof Swiper !== "undefined") {
      new Swiper(carousel, {
        slidesPerView: perViewDesktop,
        spaceBetween: 20,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          0: {
            slidesPerView: perViewMobile
          },
          768: {
            slidesPerView: perViewDesktop
          }
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
